import { GenerationOperationType, NatureOperation } from "@core-lib/enums";
import { IQualiteTiers } from "@core-lib/models";

export function showNomEmetteur(qualite: IQualiteTiers): boolean {
	return qualite?.estAvecTiers === false;
}

export function getGenerationOperationType(natureOpe: NatureOperation) {
	switch (natureOpe) {
		case NatureOperation.ImpayeRac:
			return GenerationOperationType.ImpayeRemise;
		case NatureOperation.RejetChequeRac:
			return GenerationOperationType.RejetChequeEmis;
		case NatureOperation.RejetVirementRac:
			return GenerationOperationType.RejetVirementEmis;
		case NatureOperation.RejetVirementRacDebit:
			return GenerationOperationType.RejetVirementRecu;
		case NatureOperation.AnnulChequeRac:
			return GenerationOperationType.AnnulationChequeEmis;
		case NatureOperation.AnnulChequePerimeRac:
			return GenerationOperationType.AnnulationChequePerime;
		default:
			return GenerationOperationType.LotVirement;;
	}
}
